export const VIEW_RESTART = 'password-reset/VIEW_RESTART'
export const VIEW_NEXT = 'password-reset/VIEW_NEXT'
export const VIEW_BACK = 'password-reset/VIEW_BACK'

// FORM DATA
export const UPDATE_FORM_USERNAME = 'password-reset/UPDATE_FORM_USERNAME'
export const UPDATE_FORM_USERNAME_ERROR = 'password-reset/UPDATE_FORM_USERNAME_ERROR'

export const UPDATE_FORM_DOB = 'password-reset/UPDATE_FORM_DOB'
export const UPDATE_FORM_DOB_ERROR = 'password-reset/UPDATE_FORM_DOB_ERROR'

export const UPDATE_FORM_SSN = 'password-reset/UPDATE_FORM_SSN'
export const UPDATE_FORM_SSN_ERROR = 'password-reset/UPDATE_FORM_SSN_ERROR'

export const UPDATE_FORM_ERROR = 'password-reset/UPDATE_FORM_ERROR'

// SUBMIT BUTTON
export const UPDATE_FORM_SUBMIT_DISABLED = 'password-reset/UPDATE_FORM_SUBMIT_DISABLED'
export const UPDATE_FORM_SUBMIT_TEXT = 'password-reset/UPDATE_FORM_SUBMIT_TEXT'
export const UPDATE_FORM_SUBMIT_WAIT = 'password-reset/UPDATE_FORM_SUBMIT_WAIT'
export const UPDATE_FORM_SUBMIT_INVALID = 'password-reset/UPDATE_FORM_SUBMIT_INVALID'
export const UPDATE_FORM_VALIDATION_ERROR = 'password-reset/UPDATE_FORM_VALIDATION_ERROR'
export const UPDATE_FORM_SUBMIT_ATTEMPS = 'password-reset/UPDATE_FORM_SUBMIT_ATTEMPS'
export const UPDATE_FORM_LOCKED_OUT = 'password-reset/UPDATE_FORM_LOCKED_OUT'
export const UPDATE_FORM_DEPROVISIONED = 'password-reset/UPDATE_FORM_DEPROVISIONED'
export const UPDATE_FORM_MISSING_DATA = 'password-reset/UPDATE_FORM_MISSING_DATA'

// TRACKER
export const INPUT_USERNAME = 'password-reset/INPUT_USERNAME'
export const INPUT_USERNAME_SUCCESS = 'password-reset/INPUT_USERNAME_SUCCESS'
export const INPUT_USERNAME_FAILURE = 'password-reset/INPUT_USERNAME_FAILURE'

export const INPUT_SSN = 'password-reset/INPUT_SSN'
export const INPUT_DOB = 'password-reset/INPUT_DOB'
export const SUBMIT = 'password-reset/SUBMIT'
export const SUBMIT_SUCCESS = 'password-reset/SUBMIT_SUCCESS'
export const SUBMIT_FAILURE = 'password-reset/SUBMIT_FAILURE'
export const SUBMIT_FAILURE_SERVICE = 'password-reset/SUBMIT_FAILURE_SERVICE'
export const RE_ENTRY = 'password-reset/RE_ENTRY'
export const LOCKED_OUT = 'password-reset/LOCKED_OUT'
export const DEPROVISIONED = 'password-reset/DEPROVISIONED'
export const MISSING_DATA = 'password-reset/MISSING_DATA'
export const TOGGLE_HELP_MODAL = 'password-reset/TOGGLE_HELP_MODAL'
export const TOGGLE_SERVICE_ERROR = 'password-reset/TOGGLE_SERVICE_ERROR'
